import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { AuthRouteKeys } from 'routes/enums';
import { useLogoutMutation } from 'services';
import { handleLogout as handleLogoutUtils } from 'utils/helpers';

const LogoutFeature = () => {
  const { mutateAsync } = useLogoutMutation();

  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await mutateAsync();

      handleLogoutUtils();

      toast.success('Đăng xuất thành công');

      navigate(AuthRouteKeys.Login);
    } catch (error: unknown) {}
  };

  useEffect(() => {
    handleLogout();
  }, []);

  return null;
};

export default LogoutFeature;
